<template>
  <div class="application-field">
    <div class="app_div">
      <h2 class="title">应用领域</h2>
      <div class="tabs" :class="{ 'two-tabs': tabs.length === 2 }">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['tab', { active: activeTab === index }]"
          @click="switchTab(tab, index)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class="content">
        <div class="image-container">
          <img :src="currentImage" alt="配电" :key="currentRouteKey" />
          <div class="content_bg">
            <p class="content_text" v-if="currentText">{{ currentText }}</p>
          </div>
          <!-- <p class="image-text bottom" v-if="currentText">{{ currentText }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationField",
  data() {
    return {
      tabs: [],
      activeTab: 0, // 默认选中“配电”
      currentImage: "",
      currentText: "",
      currentSource: "", // 用于存储当前的 source 参数
      currentRouteKey: 0,
    };
  },
  watch: {
    "$route.fullPath": {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        if (source !== this.currentSource) {
          this.currentSource = source;
          this.updateTabsData(source);
        }
      },
    },
  },
  methods: {
    updateTabsData(source) {
      this.activeTab = 0;
      switch (source) {
        case "product_lie_1":
        case "product_lie_2":
          this.tabs = [
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_3":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_4":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_5":
          this.tabs = [
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "物流",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
          ];
          break;
        case "product_lie_5_1":
          this.tabs = [
            {
              name: "电网巡检",
              currentImage: "https://hr2.chnsoft.com.cn/img/行业应用1.png",
              currentText:
                "无人机+四足机器人空地协同，可高效完成变电（换流）站“高-中-低”层设备区精细化巡检作业，AI自动识别杆塔异物、绝缘子破损、发热点等隐患，效率与安全性倍增。",
            },
            {
              name: "风能/光伏巡检",
              currentImage: "https://hr2.chnsoft.com.cn/img/行业应用2.jpg",
              currentText:
                "无人机快速巡检光伏板与风机叶片，四足机器人深入检查光伏背板、基座状态，AI自动生成热斑、脏污、裂纹等缺陷诊断报告。",
            },
            {
              name: "应急消防与公共安全",
              currentImage: "https://hr2.chnsoft.com.cn/img/行业应用3.png",
              currentText:
                "快速部署，无人机全局侦察火情与人员分布，四足机器人深入危险区域搜救，回传实时数据，为指挥决策提供最强支持。",
            },
            {
              name: "营区与边防",
              currentImage: "https://hr2.chnsoft.com.cn/img/行业应用4.jpg",
              currentText:
                "构建无人化巡逻防线，可应用于边防巡逻、营区周界警戒、要地守卫等场景。智能识别入侵、偷拍等行为，提升安防等级。",
            },
            {
              name: "交通运输",
              currentImage: "https://hr2.chnsoft.com.cn/img/行业应用5.jpg",
              currentText:
                "为交通运维、管理部门配上了“天眼”和“地勤”，实现对路桥、服务区、火车站、地铁站等区域从高空到地面的各种设施进行高频、高精度巡检。保障交通运输稳定、安全。",
            },
            // { name: '港口', currentImage: 'https://hr2.chnsoft.com.cn/img/gangKou.png', currentText: '巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。' },
            // { name: '基础建设', currentImage: 'https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg', currentText: '巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。' },
          ];
          break;
        case "product_lie_6":
        case "product_lie_7":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;

        case "product_lie_8":
          this.tabs = [
            {
              name: "电力（室外）",
              currentImage: "https://hr2.chnsoft.com.cn/img/电力（室外）.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能电力系统运维体系建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "城市保障",
              currentImage: "https://hr2.chnsoft.com.cn/img/城市保障图.jpg",
              currentText:
                "自主进入高危区域执行灭火救援任务，减少人员伤亡，提升城市应急消防的处置效率与安全性。",
            },
            {
              name: "石化",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油化工.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "企业园区",
              currentImage: "https://hr2.chnsoft.com.cn/img/企业园区.jpg",
              currentText:
                "快速响应，可自主进入高温浓烟等高危区域执行灭火任务，降低人员涉险风险，提升园区应急消防的处置效率。",
            },
          ];
          break;
        case "product_lie_9":
          this.tabs = [
            {
              name: "电力（室内）",
              currentImage: "https://hr2.chnsoft.com.cn/img/电力室内.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能电力系统运维体系建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "城市保障",
              currentImage: "https://hr2.chnsoft.com.cn/img/城市保障图.jpg",
              currentText:
                "自主进入高危区域执行灭火救援任务，减少人员伤亡，提升城市应急消防的处置效率与安全性。。",
            },
            {
              name: "石化",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油化工.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "工业厂房",
              currentImage: "https://hr2.chnsoft.com.cn/img/工业厂房.jpg",
              currentText:
                "快速响应，可自主进入高温浓烟等高危区域执行灭火任务，降低人员涉险风险，提升厂房应急消防的处置效率。",
            },
          ];
          break;
        case "product_lie_8_1":
          this.tabs = [
            {
              name: "电力",
              currentImage: "https://hr2.chnsoft.com.cn/img/电力2.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能电力系统运维体系建设。",
            },
            {
              name: "石化",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油化工.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "工业厂房",
              currentImage: "https://hr2.chnsoft.com.cn/img/工业厂房.jpg",
              currentText:
                "快速响应，可自主进入高温浓烟等高危区域执行灭火任务，降低人员涉险风险，提升厂房应急消防的处置效率。",
            },
            {
              name: "城市保障",
              currentImage: "https://hr2.chnsoft.com.cn/img/城市保障图.jpg",
              currentText:
                "自主进入高危区域执行灭火救援任务，减少人员伤亡，提升城市应急消防的处置效率与安全性。",
            },
          ];
          break;
        case "product_lie_8_2":
          this.tabs = [
            {
              name: "电力（室内）",
              currentImage: "https://hr2.chnsoft.com.cn/img/电力室内.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能电力系统运维体系建设。",
            },
            {
              name: "设备机房",
              currentImage: "https://hr2.chnsoft.com.cn/img/设备机房.jpg",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能设备机房等场景运维体系建设。",
            },
          ];
          break;
        case "product_lie_10":
          this.tabs = [
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/环保.jpg",
              currentText:
                "无人船可搭载多种水样采集与分析设备；船体小巧，机动灵活，高效排查隐蔽排污地点，助力环保事业。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/边海防.jpg",
              currentText:
                "实现海疆立体化巡逻监控，增强边境安全和应急响应能力。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "应急救援",
              currentImage: "https://hr2.chnsoft.com.cn/img/应急救援.png",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "大型水库",
              currentImage: "https://hr2.chnsoft.com.cn/img/大型水库.jpg",
              currentText:
                "搭载专业设备，实时监测水质，检查大坝裂缝、渗漏隐患。与无人机协同，扩大巡检范围，快速察觉周边非法活动，从水质到坝体，从水域到周边，全方位保障水库安全与生态。",
            },
            {
              name: "水电站",
              currentImage: "https://hr2.chnsoft.com.cn/img/水电站.jpg",
              currentText:
                "可搭载声呐探测水下地形，排查水轮机故障隐患。凭借高清摄像头，监测大坝外观、周边环境。配合水质监测设备，掌握水体状况，为水电站设备安全、稳定运行及水质管理提供有力支持。",
            },
            {
              name: "海洋经济",
              currentImage: "https://hr2.chnsoft.com.cn/img/海洋经济.jpg",
              currentText:
                "自主巡航收集水质、生物数据，助力精准调控。支持无人机起降，协同开展大范围监测，及时发现病害、非法捕捞等情况。实现智能化、精细化管理。",
            },
            {
              name: "海上风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/海上风电.jpg",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "水上光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/上光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
          ];
          break;
        case "product_lie_13":
        case "product_lie_13_1":
        case "product_lie_13_2":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_14":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.png",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_15":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_16":
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_17":
          this.activeTab = 0;
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        case "product_lie_18":
          this.activeTab = 0;
          this.tabs = [
            {
              name: "输电",
              currentImage: "https://hr2.chnsoft.com.cn/img/shuDian.jpg",
              currentText:
                "巡检提速、排查提准、维护提效，效能提智，护航输电网络稳定运行。",
            },
            {
              name: "变电",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianDian.png",
              currentText:
                "巡检提速、监控提准、应急提效，处置提智，赋能数字化变电站运维体系建设。",
            },
            {
              name: "配电",
              currentImage: "https://hr2.chnsoft.com.cn/img/配电.png",
              currentText:
                "巡检增效、定位增准、抢修增速，效能提智，保障配电网络安全可靠。",
            },
            {
              name: "直流",
              currentImage: "https://hr2.chnsoft.com.cn/img/室内巡检.jpg",
              currentText:
                "巡检提效、监控提准、应急提速，处置提智，空地一体护航换流站安全运行。",
            },
            {
              name: "光伏",
              currentImage: "https://hr2.chnsoft.com.cn/img/光伏.png",
              currentText:
                "巡检提效、故障提准、维护提效，效能提智，实现光伏电站无人值守环境下稳定运行。",
            },
            {
              name: "风电",
              currentImage: "https://hr2.chnsoft.com.cn/img/风电.png",
              currentText:
                "巡检提效、监测提精、维护提速，效能提智，智能化技术赋能风电无人化巡检。",
            },
            {
              name: "抽水蓄能",
              currentImage: "https://hr2.chnsoft.com.cn/img/抽水蓄能.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，护航抽水蓄能高效运维。",
            },
            {
              name: "石油",
              currentImage: "https://hr2.chnsoft.com.cn/img/石油.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "天然气",
              currentImage: "https://hr2.chnsoft.com.cn/img/天然气.png",
              currentText:
                "巡检增效、监测提精、应急增速，效能提智，空地一体确保管道及设备的安全监控和维护。",
            },
            {
              name: "执法",
              currentImage: "https://hr2.chnsoft.com.cn/img/zhiFa.jpg",
              currentText:
                "巡查增效、侦查增准、布控增密，执法增智，助力新型公安警务系统建设。",
            },
            {
              name: "应急",
              currentImage: "https://hr2.chnsoft.com.cn/img/yingJi.jpg",
              currentText:
                "响应提速、监测提效、救援提质，效能提智，强化应急实战能力。",
            },
            {
              name: "轨道交通",
              currentImage: "https://hr2.chnsoft.com.cn/img/轨道交通.png",
              currentText:
                "巡检提效、监控提精、应急提速，效能提智，智能化技术助力企业高效运维。",
            },
            {
              name: "边海防",
              currentImage: "https://hr2.chnsoft.com.cn/img/bianHaiFang.jpg",
              currentText:
                "监控提效、侦察提精、响应提速，研判提智，筑牢边海防智慧防线。",
            },
            {
              name: "矿业",
              currentImage: "https://hr2.chnsoft.com.cn/img/kuangYe.jpg",
              currentText:
                "巡检增效、监测提精、应急增速，处置提智，助力矿业安全生产，提高生产效率与环境保护。",
            },
            {
              name: "环保",
              currentImage: "https://hr2.chnsoft.com.cn/img/huanBao.jpg",
              currentText:
                "监测增效、巡查提精、研判增智，治理提速，赋能环保生态守护，确保环境数据准确及时。",
            },
            {
              name: "港口",
              currentImage: "https://hr2.chnsoft.com.cn/img/gangKou.png",
              currentText:
                "巡检提效、监控提精、调度提速，救援提质，空地一体助力现代化港口高效运营。",
            },
            {
              name: "基础建设",
              currentImage: "https://hr2.chnsoft.com.cn/img/jiChuJianShe.jpg",
              currentText:
                "巡检增效、监测提精、施工增速、效能提智，保障基建高效推进。",
            },
          ];
          break;
        default:
          // 默认处理逻辑
          break;
      }
      // 新增：tabs更新后，自动切换到第一个tab
      if (this.tabs.length > 0) {
        this.switchTab(this.tabs[0], 0);
      } else {
        this.currentImage = "";
        this.currentText = "";
        this.activeTab = 0;
      }
    },
    switchTab(tab, index) {
      this.currentRouteKey += 1; // 每次路由变化时，更新 key
      this.activeTab = index;
      this.currentImage = "";
      this.currentImage = tab.currentImage;
      this.currentText = tab.currentText;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: PingFang SC;
  font-size: 32px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #1e242a;
  margin: 80px 0px 40px;
}

.application-field {
  text-align: center;

  .app_div {
    width: 1200px;
    margin: 0 auto;
  }
}

.tabs {
  display: flex;
  justify-content: center;
  /* 居中显示 */
  margin-bottom: 20px;
  /* padding: 0 18.75%; */
  width: 100%;
  /* gap: 21PX; */
  /* 添加 gap 间距 */
}

.tabs.two-tabs {
  gap: 40px;
}

.tab {
  /* padding: 10PX 10PX; */
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-size: 20px;
  /* gap 由父容器控制，无需再加 margin */
  padding-bottom: 10px;
  margin: 0px 10px;

  &:hover {
    font-weight: bold;
  }
}

.tab.active {
  color: #0f6bf6;
  border-color: #0f6bf6;
  font-weight: bold;
  padding: 0;
  margin: 0px 10px;
}

.content {
  /* padding: 0 18.75%; */
  padding-bottom: 80px;
}

.content img {
  width: 100%;
  height: 640px;
  border-radius: 8px;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 640px;
}

.image-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 16px;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
  z-index: 1;
}

.image-text.top {
  top: 10px;
}

.image-text.bottom {
  bottom: 6px;
  width: 100%;
  height: 80px;
  background: linear-gradient(
    1deg,
    rgba(0, 0, 0, 0.6) 12%,
    rgba(0, 0, 0, 0) 83%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  transform: none;
  /* 保证文字在蒙版中央 */
}

.content_bg {
  height: 120px;
  padding: 0px 40px 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-radius: 0.625vw;
  position: absolute;
  background: linear-gradient(
    1deg,
    rgba(30, 36, 42, 0.6) 12%,
    rgba(30, 36, 42, 0) 83%
  );
  position: absolute;
  bottom: 0px;
  width: 100%;
  border-radius: 8px;
}

.content_text {
  /* 文字居中 */
  color: #fff;
  font-size: 18px;

  width: 100%;
  text-align: center;
  line-height: 1.5;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 80px;
}

::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
